// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";

const metadata: BuiltInScriptMetadata = {
  name: "Generic Projectile",
  id: "generic-projectile",
  metadata: {
    imports: ["projectile"],
    icon: {
      "backgroundColor": 2630185,
      "layers": [
        {
          "iconKey": "fireball",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": -5,
          "color": 3264232
        }
      ]
    },
  },
};

export default metadata;
